export default (what: string) => `foo:${what}`;
